import './styles/global.css';
import 'vue-sonner/style.css';

import { createHead } from '@unhead/vue/client';
import { createApp } from './main';
import { ensureUserHydrated } from './stores';
import lozad from './utils/lozad';

// 用服务端写入的显式标记决定 hydrate / 全新 mount
const ssr = Boolean(window.__SSR__);

const observer = lozad('.lozad', {
  enableAutoReload: true,
});

observer.observe();

const { app, router, pinia } = createApp({
  language: 'zh-CN',
  cookies: document.cookie,
  ssr,
});

const head = createHead();

app.use(head);

if (ssr && window.__INITIAL_STATE__) {
  pinia.state.value = window.__INITIAL_STATE__;
}

ensureUserHydrated(pinia);

router.isReady().then(() => {
  app.mount('#app');

  const boot = document.getElementById('global-boot-progress');

  if (boot) {
    boot.classList.add('done');
    setTimeout(() => boot.remove(), 400);
  }
});
